<template>
  <div :class="btnClass">
    <svg
      v-if="info"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-info-lg"
      viewBox="0 0 16 16"
    >
      <path
        d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0"
      />
    </svg>
    <svg
      v-else-if="edit"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-pencil"
      viewBox="0 0 16 16"
    >
      <path
        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
      />
    </svg>
    <svg
      v-else-if="sync"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-arrow-clockwise"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
      />
      <path
        d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
      />
    </svg>
    <svg
      v-else-if="add"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-plus"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
      />
    </svg>
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-trash-fill"
      viewBox="0 0 16 16"
    >
      <path
        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Boolean,
      default: false,
    },
    sync: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClass() {
      if (this.info) return "infoBtn";
      if (this.edit) return "editBtn";
      if (this.sync) return "syncBtn";
      if (this.add) return "addBtn";
      return "deleteBtn";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/index.scss";

.infoBtn,
.editBtn,
.syncBtn,
.addBtn,
.deleteBtn {
  width: 34px;
  height: 34px;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  margin: 0 auto;
  padding: 0.25rem 0.5rem;
  text-align: center;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  cursor: pointer;

  & svg {
    width: 100%;
    height: 100%;
  }
}

.infoBtn {
  color: #fff;
  background-color: #469df8;
  border-color: #469df8;
  &:hover {
    background-color: #5aa8ff;
    border-color: #5aa8ff;
  }
}
.syncBtn,
.editBtn {
  color: #000;
  background-color: #ffc107;
  border-color: #ffc107;
  &:hover {
    color: #000;
    background-color: #ffca2c;
    border-color: #ffc720;
  }
}

.addBtn {
  color: #fff;
  background-color: #d3d4df;
  border-color: #d3d4df;
  &:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
  }
}

.deleteBtn {
  color: #fff;
  background-color: $buttonColor;
  border-color: $buttonColor;
  padding-right: 0.55rem;
  padding-left: 0.45rem;
  & svg {
    width: 115%;
    height: 100%;
  }
  &:hover {
    background-color: $buttonHover;
    border-color: $buttonHover;
  }
}
</style>
